import styled from "styled-components";

export const Styles = styled.div`
  &.mode_view {
    .ant-table-content {
      padding-bottom: 0px;
    }
  }

  .last-cell {
    position: relative;
    background: #eefaffff;
  }
  .container-btn-to-sheet {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 4px;
  }

  .ant-table-content {
    padding-bottom: 10px;
  }

  &.collapse-table {
    tbody {
      display: none;
    }
    .ant-table-content {
      padding-bottom: 0px;
    }
  }
  &.pdf-mode {
    .ant-table-container {
      overflow: visible !important;
    }

    .ant-table-content {
      overflow: visible !important;
    }

    .ant-table-body {
      overflow-x: visible !important;
      overflow-y: visible !important;
    }

    .ant-table {
      overflow: visible !important;
    }

    .ant-table-thead,
    .ant-table-tbody {
      overflow: visible !important;
    }
  }
  .container_collapse_button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .action-buttons-container {
    min-height: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
    &.view {
      display: none;
    }
    &.preview {
      .button {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
    .button {
      margin-left: 3px;
      color: white;
      border-radius: 4px;
      padding: 1px 3px;
      height: 20px;
      font-size: 12px;
      font-weight: bold;
      border: none;
      cursor: pointer;
    }
    .container_button_action {
      display: flex;
      justify-content: space-end;
    }
    .insert-button {
      position: absolute;
      z-index: 10;
      right: 0; // đổi từ left: 0 sang right: 0
      background-color: #001f7f;
      -webkit-clip-path: polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%);
      clip-path: polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%);

      &:hover {
        background-color: rgb(9, 62, 219);
      }

      &.top {
        top: -10.5px;
      }

      &.bottom {
        bottom: -10.5px;
      }
    }

    .remove-button {
      background-color: #ed1c24;
      color: white;
      width: 30px;
      &:hover {
        background-color: rgb(184, 72, 53);
      }
    }

    .sort-button {
      background-color: #1890ff;
      height: 20px;
      color: white;
      width: 31px;
      border-radius: 4px 0 0 4px;
      &:hover {
        background-color: rgb(9, 99, 184);
      }
    }
  }
  .ant-table-cell {
    position: relative;
  }

  .ant-table-container {
    .btn-collapse-table {
      min-width: 50px;
      max-width: 60px;
      text-align: center;
    }
    .ant-input-number {
      width: 100%;
    }
    .ant-table-content {
      overflow: scroll;
      &:has(.ql-tooltip) {
        overflow: unset !important;
      }
    }
    th {
      background: #e8e8e8;
    }
    .ant-table-cell {
      border: 0.5px solid #d9d9d9; /* Light gray border color */
      padding: 0px;
    }

    /* Add border between table rows */
    .ant-table-tbody tr {
      border-bottom: 0.5px solid #d9d9d9; /* Light gray border for row separation */
    }
  }
`;
